import React from 'react';
import Loadable from 'react-loadable';

import LoadableLoading from 'components/LoadableLoading';
import { IProps } from './interface';
import { getAvailableColumns, getFilterColumns } from './api';

export const path = '/chrona/objects';

const PageChronaObjectList: React.FC<IProps> = (props) => {
  const loader = {
    page: () => import('./page'),
    i18n: () => import('./ru.json'),
    columns: getAvailableColumns,
    filters: getFilterColumns,
  };

  const LoadableMap = Loadable.Map({
    loader,
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return (
        <Page
          i18n={loaded.i18n}
          columns={loaded.columns}
          filters={loaded.filters[0].columns}
          {...props}
          {...loadedProps}
        />
      );
    },
  });

  return <LoadableMap {...props} />;
};

export default PageChronaObjectList;
